import {Directive, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {FormService} from 'app/core/services/form.service';

@Directive({
    selector: '[formControlName], [formControl]',
})
export class CustomControlDirective {
    @Input() formControlName: string;
    private control: AbstractControl;

    @Input() set formControl(v: AbstractControl) {
        this.control = v;
    }

    get formControl() {
        return this.control ? this.control : this.formControlName ? this.fs.getControl(this.formControlName) : null;
    }

    constructor(private fs: FormService) {}
}
